import React from "react";
import { IonBackdrop, IonContent, IonIcon, IonText } from "@ionic/react";
import { alertCircleOutline } from "ionicons/icons";
import showInMobile from "../../../img/ShowInMobileCMEDDev12.png";

type ShowInMobileErrorBackdrop = {};
const ShowInMobileErrorBackdrop: React.FC<ShowInMobileErrorBackdrop> = () => {
  return (
    <>
      <IonContent
        style={{
          fontFamily: "Poppins",
        }}
      >
        <IonBackdrop visible={true} style={{ opacity: 0.25 }}></IonBackdrop>
        <div id="box">
          <IonIcon icon={alertCircleOutline} color="danger" size="large" />
          <IonText className="ion-text-center ion-no-margin" color="danger">
            <b>Oops - Your market data is not enabled for mobile!</b>
          </IonText>
          <IonText>
            <p className="ion-no-margin">To enable it, follow these steps:</p>
            <p className="ion-no-margin">
              1. Log in to the CME Direct Desktop Trading client.
            </p>
            <p className="ion-no-margin">
              2. Add a new Futures Market grid or select an existing Futures
              Market Grid.
            </p>
            <p className="ion-no-margin">3. Right-click on the grouping.</p>
            <p className="ion-no-margin">4. Select Group name “Group *****”.</p>
            <p className="ion-no-margin">5. Select “Show in Mobile”.</p>
            <p style={{ fontSize: "var(--one-font-size-10)" }}></p>
            <p className="ion-no-margin">Refer the image below:</p>
            <p style={{ fontSize: "var(--one-font-size-10)" }}></p>
          </IonText>
          <img src={showInMobile} style={{ width: "95%" }} />
          <IonText>
            <p style={{ fontSize: "var(--one-font-size-10)" }}></p>
            <p className="ion-no-margin">
              Once you have completed these steps, your market data will be
              enabled and you will be able to view it on your mobile device!
            </p>
          </IonText>
          <br></br>
        </div>
      </IonContent>
    </>
  );
};

export default ShowInMobileErrorBackdrop;
